module.exports = __webpack_public_path__ + "img/imgCard03.3bf94bd4.jpg";